<ng-container *ngIf="hasInsightsAccess; else noInsightsAccess">
<fieldset class="financial-issues-panel">
	<legend>Error log</legend>
	<p class="panel-intro">
		Review the latest finance integration issues and jump straight into traceparent investigation without copying values around by hand. Click a support trace code to open the trace searcher automatically.
	</p>
	<dx-data-grid #grid id="gridContainer" [dataSource]="jobLogSourceOData" noDataText="No financial integration issues found." keyExpr="id" [showBorders]="true" [wordWrapEnabled]="true" [rowAlternationEnabled]="true" [hoverStateEnabled]="true" [remoteOperations]="{
		filtering: true,
		sorting: true,
		paging: true,
		grouping: false
	  }">
		<dxo-summary>
			<dxi-group-item column="id" summaryType="min" [alignByColumn]="true">
			</dxi-group-item>
		</dxo-summary>
		<dxi-sort-by-group-summary-info summaryItem="id"></dxi-sort-by-group-summary-info>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-load-panel [enabled]="true"></dxo-load-panel>
		<dxi-column dataField="id" [visible]="false" [width]="100" [calculateCellValue]="calculateCellValue" [showInColumnChooser]="false" sortOrder="desc"></dxi-column>
		<dxi-column dataField="creationDate" caption="Date" [width]="165" dataType="datetime" format="dd/MM/yyyy HH:mm" sortOrder="desc"></dxi-column>
		<dxi-column caption="Error details" [width]="760" cellTemplate="messageCellTemplate"></dxi-column>
		<dxi-column dataField="sessionIdentifier" caption="Link run" [width]="520" [sortOrder]="'desc'" [calculateCellValue]="null" cellTemplate="groupLikeTemplate"></dxi-column>


		<div *dxTemplate="let cell of 'groupLikeTemplate'">
			<ng-container *ngIf="shouldShowGroupHeader(cell.rowIndex)">
				<div class="group-header">
					{{ padGroupingText(cell) }}
				</div>
			</ng-container>
		</div>
		<div *dxTemplate="let cell of 'messageCellTemplate'">
			<div class="message-cell">
				<div class="message-cell__meta" *ngIf="hasTraceparentInCell(cell)">
					<span class="message-pill message-pill--trace">Support trace detected</span>
				</div>
				<div class="message-cell__meta" *ngIf="getAdditionalDetailValuesFromCell(cell).length > 0">
					<span class="message-pill" *ngFor="let detail of getAdditionalDetailValuesFromCell(cell)">{{ detail }}</span>
				</div>
				<div class="message-cell__text">
					{{ getMessagePrefixFromCell(cell) }}
					<button type="button" class="trace-code-button" *ngIf="hasTraceparentInCell(cell)" (click)="onTraceparentCodeClick(cell, $event)">
						{{ getTraceparentIdFromCell(cell) }}
					</button>
					{{ getMessageSuffixFromCell(cell) }}
				</div>
				<div class="message-cell__footer" *ngIf="hasTraceparentInCell(cell)">
					<span class="message-cell__hint">Only the trace code is clickable.</span>
				</div>
			</div>
		</div>
		<dxo-summary>
			<dxi-group-item column="id" summaryType="max" [alignByColumn]="true">
			</dxi-group-item>
		</dxo-summary>

		<dxo-selection [showCheckBoxesMode]="'none'"></dxo-selection>
		<dxo-search-panel [visible]="true" placeholder="Search errors, link names, company, or session"></dxo-search-panel>
		<dxo-paging [pageSize]="10"></dxo-paging>
		<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]" [showInfo]="true"></dxo-pager>
		<dxo-group-panel [visible]="false"></dxo-group-panel>
		<dxo-grouping #expand [autoExpandAll]="false">
		</dxo-grouping>
	</dx-data-grid>
</fieldset>

<fieldset #traceparentSearchSection class="financial-issues-panel traceparent-panel">
	<legend>Traceparent ID searcher</legend>
	<p class="panel-intro">
		Paste the complete support error or just the traceparent ID. The screen will pull out the <code>00-...-00</code> value and start searching automatically as soon as it recognizes a valid trace.
	</p>

	<div class="traceparent-toolbar">
		<dx-text-box [(value)]="traceparentId" [showClearButton]="true" valueChangeEvent="keyup input" placeholder="Paste a support error or a traceparent ID" (onValueChanged)="onTraceparentInputChange($event.value)" (onEnterKey)="sendTraceparentid()">
	</dx-text-box>
		<dx-button (onClick)="sendTraceparentid()" [text]="(traceparentLoading$ | async) ? 'Searching...' : 'Search now'" [disabled]="(traceparentLoading$ | async) || !canSearchTraceparent(traceparentId)" type="default"></dx-button>
		<dx-button (onClick)="clearTraceparentSearch()" [disabled]="traceparentLoading$ | async" text="Clear" stylingMode="outlined"></dx-button>
	</div>
	<div class="traceparent-status" *ngIf="traceparentStatus$ | async as traceparentStatus">
		{{ traceparentStatus }}
	</div>
	<div class="traceparent-copy-status" *ngIf="traceparentCopied$ | async as traceparentCopied">
		{{ traceparentCopied }}
	</div>

	<dx-data-grid id="gridContainer" [dataSource]="traceparentInfo$ | async" [showBorders]="true" [width]="'100%'" (onCellClick)="onCellClick($event)">
		<dxo-load-panel [enabled]="true"></dxo-load-panel>
		<dxo-paging [pageSize]="10"></dxo-paging>
		<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
		<dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
		<dxo-group-panel [visible]="false"></dxo-group-panel>
		<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	</dx-data-grid>
</fieldset>
</ng-container>

<ng-template #noInsightsAccess>
	<fieldset class="financial-issues-panel">
		<legend>Error log</legend>
		<p class="panel-intro">You do not have access to the financial issues overview.</p>
	</fieldset>
</ng-template>
